import { FeatureTextWrapper, FeatureTextText } from './FeatureText.styled';
interface FeatureTextProps {
  text: string;
  featureText?: string;
  direction?: 'right' | 'left';
}

export const FeatureText = ({
	text,
	featureText,
	direction = 'right',
}: FeatureTextProps) => {

	if (!text && !featureText) return null;

	return (
		<FeatureTextWrapper>
			<FeatureTextText>
				{direction === 'right' ? (
					<>{featureText} <span>&nbsp;{text}&nbsp;</span></>
				) : (
					<><span>{text}</span> {featureText}</>
				)}
			</FeatureTextText>
		</FeatureTextWrapper>
	);
};

FeatureText.displayName = 'FeatureText';
